const StorageSettings = {
  sessionKey: 'session',
  tokenKey: 'token',
}

export default StorageSettings
